import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { API_URL } from "../../redux/constants";
import { getUserList } from "../../redux/UserActions";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";
import User from "./User";

export default function UserList(props) {
  const userSelector = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { status } = useParams();

  const [expanded, setExpanded] = useState(true);
  const [rows, setRows] = useState([]);

  function setSelectedChat(caseId) {
    props._handleSelected(caseId);
  }

  useEffect(() => {
    setRows(userSelector.activeConversations);
  }, [userSelector.activeConversations]);

  useEffect(() => {
    setRows(userSelector.archivedConversations);
  }, [userSelector.archivedConversations]);

  useEffect(() => {
    props._handleExpanded(expanded);
  }, [expanded]);

  useEffect(() => {
    dispatch(
      getUserList({
        messageStatus: status,
      })
    );
  }, [status]);

  return (
    <div
      className={
        "z-10 fixed top-0 right-0 border-l border-r bg-white " +
        (expanded ? "w-96" : "w-16")
      }
    >
      <div className="absolute w-full h-14 flex bg-white flex-row">
        <button
          aria-haspopup="true"
          onClick={() => setExpanded(!expanded)}
          className="m-2 text-gray-700 rounded-full focus:outline-none hover:text-gray-600 hover:bg-gray-200"
        >
          {!expanded ? (
            <ChevronLeftIcon className="w-8 h-8 text-gray-600 fill-current" />
          ) : (
            <ChevronRightIcon className="w-10 h-8 text-gray-600 fill-current" />
          )}
        </button>
        <input
          type="search"
          name="q"
          className={
            "w-full m-2 text-sm text-black bg-gray-200 border border-transparent rounded-lg appearance-none focus:bg-white focus:outline-none focus:border-blue-500 focus:text-gray-900 focus:shadow-outline-blue " +
            (expanded ? "" : "hidden")
          }
          placeholder="Filter..."
          onChange={(e) => {}}
          autocomplete="off"
        />
      </div>
      <div
        className={
          "flex flex-col h-screen pt-14 overflow-y-auto gap-y-1 " +
          (expanded ? "" : "items-center")
        }
      >
        {rows.map((chat) => (
          <User
            expanded={expanded}
            caseId={chat.caseId}
            _handleSelected={(e) => setSelectedChat(e)}
            name={{
              firstName:
                chat?.people[0]?._id["$oid"] != userSelector.user._id
                  ? chat.people[0]?.firstName
                  : chat.people[1].firstName,
              lastName:
                chat?.people[0]?._id["$oid"] != userSelector.user._id
                  ? chat.people[0].lastName
                  : chat.people[1].lastName,
            }}
            profilePicture={
              API_URL +
              "image/profile/" +
              (chat?.people[0]?._id["$oid"] != userSelector.user._id
                ? String(chat?.people[0]?._id["$oid"])
                : String(chat?.people[1]?._id["$oid"]))
            }
          />
        ))}
      </div>
    </div>
  );
}
